// TODO видео с шагами
// import { Steps } from "@components/steps";
import { CookiesConsent } from "@components/cookies-consent";

class App {
  constructor() {
    this.init = this.init.bind(this);
  }

  async init() {
    // TODO видео с шагами
    const modules = [];
    // modules.push(new Steps());
    modules.push(new CookiesConsent());

    modules.forEach((module) => module.init());

    if (window.location.hash !== "") {
      setTimeout(() => {
        const anchorElement = document.querySelector(window.location.hash);

        if (anchorElement !== null) {
          anchorElement.scrollIntoView({ block: "start", behavior: "instant" });
        }
      }, 0);
    }
  }
}

export { App };
